import { render, staticRenderFns } from "./ScrollingBanner.vue?vue&type=template&id=5c3a9705&scoped=true"
import script from "./ScrollingBanner.vue?vue&type=script&lang=js"
export * from "./ScrollingBanner.vue?vue&type=script&lang=js"
import style0 from "./ScrollingBanner.vue?vue&type=style&index=0&id=5c3a9705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a9705",
  null
  
)

export default component.exports